import CLIENT from '../utils/restClient';
import Logger, { LOG_LEVELS } from '../utils/logger';
import { FilingTypeEnum } from '../utils/enums';
import _ from 'underscore';
const MODULE_NAME = 'CONTENT_MODULE';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME + '.' + name;
}
function formatFrequencyObject(freq) {
  return freq.values.map(elm =>
    ({ id: elm.value, languageString: "filingFrequency_" + elm.name }));
}
function formatCountryListObject(country) {
  if (country) {
    return country.map(elm =>
      ({ countryCode: elm.name, countryName: elm.value }));
  }
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const LOAD_VATNUMBER_RULES = namespaced('LOAD_VATNUMBER_RULES');
const LOAD_VATNUMBER_RULES_OK = namespaced('LOAD_VATNUMBER_RULES_OK');
const LOAD_VATNUMBER_RULES_FAIL = namespaced('LOAD_VATNUMBER_RULES_FAIL');
const LOAD_REPORT_PERIODICITY_OPTIONS = namespaced('LOAD_REPORT_PERIODICITY_OPTIONS');
const LOAD_REPORT_PERIODICITY_OPTIONS_OK = namespaced('LOAD_REPORT_PERIODICITY_OPTIONS_OK');
const LOAD_REPORT_PERIODICITY_OPTIONS_FAIL = namespaced('LOAD_REPORT_PERIODICITY_OPTIONS_FAIL');
const LOAD_FREQUENCY = namespaced('LOAD_FREQUENCY');
const LOAD_FREQUENCY_OK = namespaced('LOAD_FREQUENCY_OK');
const LOAD_FREQUENCY_FAIL = namespaced('LOAD_FREQUENCY_FAIL');

export const ACTION_TYPES = {
  LOAD,
  LOAD_OK,
  LOAD_FAIL,
  LOAD_VATNUMBER_RULES,
  LOAD_VATNUMBER_RULES_OK,
  LOAD_VATNUMBER_RULES_FAIL,
  LOAD_REPORT_PERIODICITY_OPTIONS,
  LOAD_REPORT_PERIODICITY_OPTIONS_OK,
  LOAD_REPORT_PERIODICITY_OPTIONS_FAIL,
  LOAD_FREQUENCY,
  LOAD_FREQUENCY_OK,
  LOAD_FREQUENCY_FAIL
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = { data: undefined, loading: false, error: null }, action) => {
  log.debug('updateSubStateFromAction: ', action, state);
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD:
        return Object.assign({}, state, { loading: true, error: null });
      case LOAD_OK:
        return Object.assign({}, state, { data: action.content, loading: false, error: null });
      case LOAD_FAIL:
        return Object.assign({}, state, { data: undefined, loading: false, error: action.error });
      case LOAD_VATNUMBER_RULES:
        return Object.assign({}, state, { loading: true, error: null });
      case LOAD_VATNUMBER_RULES_OK:
        return Object.assign({}, state, { vatNumberRules: action.content, loading: false, error: null });
      case LOAD_VATNUMBER_RULES_FAIL:
        return Object.assign({}, state, { vatNumberRules: undefined, loading: false, error: action.error });
      case LOAD_REPORT_PERIODICITY_OPTIONS:
        return Object.assign({}, state, { loading: true, error: null });
      case LOAD_REPORT_PERIODICITY_OPTIONS_OK:
        return Object.assign({}, state, { reportsPeriodicityOptions: action.response, loading: false, error: null });
      case LOAD_REPORT_PERIODICITY_OPTIONS_FAIL:
        return Object.assign({}, state, { reportsPeriodicityOptions: undefined, loading: false, error: action.error });
      case LOAD_FREQUENCY:
        return Object.assign({}, state, { loading: true, error: null });
      case LOAD_FREQUENCY_OK:
        return Object.assign({}, state, { contentData: action.content, loading: false, error: null });
      case LOAD_FREQUENCY_FAIL:
        return Object.assign({}, state, { contentData: undefined, loading: false, error: action.error });
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState);
  return newState;
};

export const API = {
  doLoad: () => {
    log.debug('doLoad: ');
    return (dispatch, getState) => {
      dispatch({ type: LOAD });
      return CLIENT.getContent()
        .then((content) => {
          log.debug('doLoad: success: ', content);
          dispatch({ type: LOAD_OK, content });
        })
        .catch((error) => {
          log.debug('doLoad: failure: ', error);
          dispatch({ type: LOAD_FAIL, error });
        });
    }
  },
  getVATNumberRules: () => {
    return (dispatch, getState) => {
      dispatch({ type: LOAD_VATNUMBER_RULES });
      return CLIENT.getVATNumberRules()
        .then((response) => {
          log.debug('getVATNumberRules:  ', response.EUROPEVATREG.RegularExpressions);

          var content = _.map(response.EUROPEVATREG.RegularExpressions, (stringRegex, key) => { return { key: key, value: new RegExp(stringRegex) } })

          log.debug('getVATNumberRules:  ', content);

          dispatch({ type: LOAD_VATNUMBER_RULES_OK, content });
        })
        .catch((error) => {
          dispatch({ type: LOAD_VATNUMBER_RULES_FAIL, error });
        });
    }
  },
  getContentData: () => {
    return (dispatch, getState) => {
      dispatch({ type: LOAD_FREQUENCY });
      
      return CLIENT.getContentData()
        .then((response) => {
          log.debug('getFrequency: ', response);

          dispatch({
            type: LOAD_FREQUENCY_OK, content:
            {
              filingFrequencies: formatFrequencyObject(response.find(o => o.name === 'TReturnPeriodTimeType')),
              vatReturnFrequency: formatFrequencyObject(response.find(o => o.name === 'TVATNumberVATReturnFrequency')),
              ecListingFrequency: formatFrequencyObject(response.find(o => o.name === 'TVATNumberECListingFrequency')),
              intrastatFrequency: formatFrequencyObject(response.find(o => o.name === 'TVATNumberIntrastatFrequency')),
              localListingFrequency: formatFrequencyObject(response.find(o => o.name === 'TVATNumberLocalListingFrequency')),
              ossUnionFrequency: formatFrequencyObject(response.find(o => o.name === 'TVATNumberOssUnionFrequency')),
              ossImportFrequency: formatFrequencyObject(response.find(o => o.name === 'TVATNumberOssImportFrequency')),
              euCountryList: formatCountryListObject(response.find(o => o.name === 'TOSSEUCountry').euCountry),
              countryList: formatCountryListObject(response.find(o => o.name === 'TCountryList').country),
              modeOfTransport: response.find(o => o.name === 'TModeOfTransport').values,
              deliveryConditions: response.find(o => o.name === 'TDeliveryConditions').values,
              transactionType: response.find(o => o.name === 'TTransactionType').values,
              listingLineType: response.find(o => o.name === 'TICListingLineType').values
            }
          });
        })
        .catch((error) => {
          dispatch({ type: LOAD_FREQUENCY_FAIL, error });
        });
    }
  },

  getCountriesWithFilingsAsArray: (content, filings) => {
    log.debug('getCountriesAsArray:  ');

    const countries = (content && content.data && content.data.countries) || {};
    return Object.values(countries);
  },
  getCountriesAsArray: (content) => {
    log.debug('getCountriesAsArray:  ');

    const countries = (content && content.data && content.data.countries) || {};
    return Object.values(countries);
  },
  getCountryById: (content, id) => {
    log.debug('getCountryById:  ', id);

    const countries = (content && content.data && content.data.countries) || {};
    return countries[id];
  },
  getCountryByCode: (content, code) => {
    log.debug('getCountryByCode:  ', code);

    const countries = (content && content.data && content.data.countries) || {};
    // TODO: No!
    for (var key in countries) {
      if (countries[key].isoCode === code) {
        return countries[key];
      }
    }
    return null;
  },
  getFilingTypeById: (content, id) => {
    log.debug('getFilingTypeById:  ', id);

    const filingTypes = (content && content.data && content.data.filingTypes) || {};
    return filingTypes[id];
  },
  getReportTypeLanuageStringById: (content, id) => {
    log.debug('getReportTypeById:  ', id);

    const reportTypes = (content && content.data && content.data.reportTypes) || {};
    return reportTypes[id] && reportTypes[id].languageString;
  },
  getFilingReportTypes: (content, filingTypeId) => {
    log.debug('getFilingReportTypes()');
    switch (filingTypeId) {
      case FilingTypeEnum.ECLISTING:
        return (content && content.data && content.data.ecListingReportTypes) || {};
      case FilingTypeEnum.LOCALLISTING:
        return (content && content.data && content.data.localListingFilingReportTypes) || {};
      case FilingTypeEnum.REVERSECHARGELISTING:
        return (content && content.data && content.data.reverseChargeListingFilingReportTypes) || {};
      case FilingTypeEnum.VATBOOKS:
        return (content && content.data && content.data.vatBookFilingReportTypes) || {}
      default:
        return (content && content.data && content.data.filingReportTypes) || {};
    }

  },
  //Creates a dictionary of the id, and the shortName value for objects in content.json 
  getDict: (object, key = "id", value = "shortName") => {
    log.debug('getDict(object, key, value):  ', object, key);
    const objectValues = object || {};
    let dict = {};
    Object.values(objectValues).forEach((entry) => dict[entry[key]] = entry[value]);
    return dict;
  },

  getReportPeriodicityOptions: () => {
    return (dispatch) => {
      dispatch({ type: LOAD_REPORT_PERIODICITY_OPTIONS });

      return CLIENT.getReportPeriodicityOptions()
        .then((response) => {
          dispatch({ type: LOAD_REPORT_PERIODICITY_OPTIONS_OK, response });
        })
        .catch((error) => {
          dispatch({ type: LOAD_REPORT_PERIODICITY_OPTIONS_FAIL, error });
        });
    }
  },
};

export default API;

